// Login.js — branded sign-in screen shown until the user authenticates.
import React, { useState } from 'react';
import { useAuth } from './AuthContext';
import './Login.css';

function Login() {
  const { login } = useAuth();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (busy) return;
    setBusy(true);
    setError('');
    try {
      const ok = await login(username, password);
      if (!ok) {
        setError('Incorrect username or password.');
        setPassword('');
      }
    } catch {
      setError('Could not sign in — please try again.');
      setPassword('');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="login-screen">
      {/* Ambient brand glow */}
      <div className="login-glow login-glow-1" />
      <div className="login-glow login-glow-2" />

      <form className="login-card" onSubmit={handleSubmit} noValidate>
        <div className="login-brand">
          <img className="login-crest" src="/al-ettifaq-crest.png" alt="Al Ettifaq crest" width="72" height="72" />
          <h1 className="login-title">Al Ettifaq</h1>
          <p className="login-subtitle">Insights</p>
        </div>

        <div className="login-field">
          <label htmlFor="login-username">Username</label>
          <input
            id="login-username"
            type="text"
            autoComplete="username"
            autoCapitalize="none"
            spellCheck="false"
            value={username}
            onChange={(e) => { setUsername(e.target.value); setError(''); }}
            placeholder="Enter Username"
            autoFocus
          />
        </div>

        <div className="login-field">
          <label htmlFor="login-password">Password</label>
          <input
            id="login-password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => { setPassword(e.target.value); setError(''); }}
            placeholder="Enter Password"
          />
        </div>

        {error && <div className="login-error" role="alert">{error}</div>}

        <button type="submit" className="login-submit" disabled={busy}>{busy ? 'Signing in…' : 'Sign in'}</button>
      </form>
    </div>
  );
}

export default Login;
